import { createFileRoute } from '@tanstack/react-router'
import ControlDetailPage from '@/pages/(protected)/workspaces/[workspaceId]/compliance/controls/[controlDefId]'

type ControlDetailSearch = {
  from?: 'screenata-tests'
  framework?: string
  frameworkId?: string
}

export const Route = createFileRoute(
  '/(protected)/workspaces/$workspaceId/controls_/$controlDefId'
)({
  component: ControlDetailPage,
  validateSearch: (search: Record<string, unknown>): ControlDetailSearch => {
    return {
      from: search.from as ControlDetailSearch['from'],
      framework: search.framework as ControlDetailSearch['framework'],
      frameworkId: search.frameworkId as ControlDetailSearch['frameworkId'],
    }
  },
})
